'use client';
import cn from 'classnames';
import { useMemo } from 'react';

import './HighlightCardMiniList.style.scss';
import HighlightCardMini from '../HighlightCardMini/HighlightCardMini';

import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';
import { HighlightCardMiniProps } from '@/types/Builder';

type HighlightCardMiniListProps = {
  className?: string;
  cards: HighlightCardMiniProps[];
};

function HighlightCardMiniList(props: HighlightCardMiniListProps) {
  const { className = '', cards = [] } = props;

  const highlightCards = useMemo(() => {
    return cards.map((card, index) => {
      return (
        <HighlightCardMini
          key={index}
          headline={card.headline}
          description={card.description}
          image={card.image}
          ctaLink={card.ctaLink}
          ctaText={card.ctaText}
        />
      );
    });
  }, [cards]);

  return (
    <div className={cn('HighlightCardMiniList', className)}>
      {cards && cards.length > 0 && (
        <div className='shell-contained'>
          <SlickCarousel
            className='HighlightCardMiniList-carousel'
            slickSettings={{
              centerMode: true,
              dots: true,
              arrows: false
            }}
          >
            {highlightCards}
          </SlickCarousel>

          <div className='HighlightCardMiniList-desktop'>{highlightCards}</div>
        </div>
      )}
    </div>
  );
}

export default HighlightCardMiniList;
